module.exports = __webpack_public_path__ + "f.no1.8402f1b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/f.no1.jpg
// module id = PUMl
// module chunks = 0